// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var TemplateNameController = function ($scope, $modalInstance, title) {
    $scope.title = title;
    $scope.name = "";
    $scope.close = function () {
        $modalInstance.close($scope.name);
    };
    $scope.cancel = function() {
        $modalInstance.dismiss('cancel');
    };
};
TemplateNameController.$inject = ['$scope', '$uibModalInstance', 'title'];
